export default {
  title: '{{name}}-profiel bijwerken',
  form: {
    name: {
      label: 'Naam',
      placeholder: 'Volledige naam eigenaar invoeren',
    },
    email: {
      label: 'E-mail',
      placeholder: 'Persoonlijk e-mailadres eigenaar invoeren',
      tooltip: 'Persoonlijk e-mailadres van eigenaar/manager. Gebruikt als dashboard-login',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
};
